<template>
  <div class="file-upload">
    <div style="display: flex;justify-content: space-between">
      <appoint-title
        :title="serialNo + '、' + title + checkTitle"
      ></appoint-title>
      <div class="material-selection" @click="onSelection">材料库选择</div>
    </div>
    <div class="file-upload-content">{{ content }}</div>
    <div class="file-upload-wrapper">
      <div
        class="file-upload-preview"
        v-for="(item, index) of list"
        :key="index"
      >
        <div>
          <van-image
            width="55"
            height="55"
            class="pdf-icon"
            :src="item.FJURL || item.fileUrl | getValue"
          />
          <van-icon
            class="delete-icon"
            :name="require('@/assets/img/projectAppoint/delete.png')"
            @click="deleteFile(item, index)"
          ></van-icon>
        </div>
      </div>
      <van-uploader
        :after-read="onAfterRead"
        :before-read="onBeforeRead"
        max-count="1"
        accept=""
        id="android-upload"
      >
        <van-button class="upload-btn">
          <van-icon name="plus" size="40" color="#DDDDDD"
        /></van-button>
      </van-uploader>
      <!-- <van-uploader
        :after-read="onAfterRead"
        :before-read="onBeforeRead"
        max-count="1"
        v-if="list.length < 1 && isIOS"
        accept=".pdf"
        id="ios-upload"
      >
        <van-button class="upload-btn">
          <van-icon name="plus" size="40" color="#DDDDDD"
        /></van-button>
      </van-uploader> -->
    </div>
    <appoint-material
      ref="AppointMaterial"
      :title="title"
      @confirm="materialConfirm"
    ></appoint-material>
  </div>
</template>

<script>
import AppointTitle from "./appoint-title.vue";
import AppointMaterial from "./appoint-material.vue";
import api from "@/utils/api/appoint";
import { mapGetters } from "vuex";
import clonedeep from "lodash.clonedeep";
export default {
  components: { AppointTitle, AppointMaterial },
  props: {
    title: {
      type: String,
      default: "",
    },
    value: {
      type: Array,
      default: () => {
        return [];
      },
    },
    isCheck: {
      type: Boolean,
      default: false,
    },
    serialNo: {
      type: Number,
    },
    content: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      list: [],
      accept: ".pdf",
      listValue: [],
    };
  },
  watch: {},
  computed: {
    ...mapGetters("form", ["getFormConfigByName"]),
    checkTitle() {
      return this.isCheck ? "（必需）" : "（非必需）";
    },
  },
  filters: {
    getValue: function(value) {
      const file = value.substring(value.lastIndexOf(".") + 1).toLowerCase();
      if (file == "jpg" || file == "png" || file == "jpeg") {
        return value;
      }
      if(value){
        return require("@/assets/img/projectAppoint/pdf.png");
      }
    },
  },
  methods: {
    // 文件读取前的回调函数
    onBeforeRead(file) {
      // console.log(file)
      // 黑名单文件判断(固定9种类型)
      if (/.(jsp|jspx|jspf|sh|html|htm|shtml|js|htaccess)$/i.test(file.name)) {
        this.$toast("文件类型不支持");
        return false;
      }
      // 文件类型判断(由后台配置传入)
      // if (this.accept && this.accept != '*') {
      //   const nameArr = file.name.split('.')
      //   const type = '.' + nameArr[nameArr.length - 1]
      //   if (!this.accept.includes(type)) {
      //     this.$toast('文件类型不匹配')
      //     return false
      //   }
      // }
      this.$emit("onBeforeRead", file);
      return true;
    },
    // 文件读取后的回调函数
    onAfterRead(file) {
      // 此时可以自行将文件上传至服务器
      if (!(file instanceof Array)) {
        this.upload(file);
      } else {
        file.forEach((item) => {
          this.upload(item);
        });
      }
      this.$emit("onAfterRead", file);
    },
    upload(file) {
      const params = new FormData();
      console.log("file", file);
      let data = {
        fileName: file.file.name,
        fileSize: this.getSize(file.file.size),
        fileIcon: this.getType(file.file.name),
        fileStatus: 0,
        fileComplete: 0,
        fileUrl: "",
      };
      this.list.push(data);
      console.log("list", this.list);
      params.append("file", file.file);

      // this.$set(data, 'fileComplete', '10')
      // this.$set(data, 'fileStatus', 1)
      api
        .materialUpload(params, (progressEvent) => {
          let complete =
            ((progressEvent.loaded / progressEvent.total) * 100) | 0;
          this.$set(data, "fileComplete", complete);
          console.log("上传 " + complete);
        })
        .then((res) => {
          const dataRes = res.data[0];

          if (dataRes) {
            let fileData = {
              FJNAME: dataRes.fileName,
              FJURL: dataRes.fileUrl,
            };
            console.log("--res", res);
            this.$set(data, "fileStatus", 1);
            this.$set(data, "fileUrl", dataRes.fileUrl);
            this.listValue.push(fileData);
            this.$emit("input", this.listValue);
          }
        });
    },
    deleteFile(item, i) {
      this.list.splice(i, 1);
      this.listValue.splice(i, 1);
      this.$emit("input", this.listValue);
    },
    // 计算文件大小
    getSize(fileSize) {
      let size = "";
      if (fileSize < 0.1 * 1024) {
        // 小于0.1KB，则转化成B
        size = fileSize.toFixed(2) + "B";
      } else if (fileSize < 0.1 * 1024 * 1024) {
        // 小于0.1MB，则转化成KB
        size = (fileSize / 1024).toFixed(2) + "KB";
      } else if (fileSize < 0.1 * 1024 * 1024 * 1024) {
        // 小于0.1GB，则转化成MB
        size = (fileSize / (1024 * 1024)).toFixed(2) + "MB";
      } else {
        // 其他转化成GB
        size = (fileSize / (1024 * 1024 * 1024)).toFixed(2) + "GB";
      }

      const sizeStr = size + ""; // 转成字符串
      const index = sizeStr.indexOf("."); // 获取小数点处的索引
      const dou = sizeStr.substr(index + 1, 2); // 获取小数点后两位的值
      if (dou == "00") {
        // 判断后两位是否为00，如果是则删除00
        return sizeStr.substring(0, index) + sizeStr.substr(index + 3, 2);
      }
      return size;
    },
    // 获取文件类型
    getType(fileType) {
      let type = fileType.split(".")[fileType.split(".").length - 1];
      if (
        type == "png" ||
        type == "jpg" ||
        type == "jpeg" ||
        type == "svg" ||
        type == "gif"
      ) {
        type = require("@/assets/img/projectAppoint/jpg_png.png");
      } else if (type == "rar" || type == "zip" || type == "7z") {
        type = require("@/assets/img/projectAppoint/zip_rar_7z.png");
      } else if (type == "pdf") {
        type = require("@/assets/img/projectAppoint/pdf.png");
      } else {
        type = require("@/assets/img/projectAppoint/jpg_png.png");
      }
      return type;
    },
    //材料库选择
    onSelection() {
      this.$refs["AppointMaterial"].showUnit = true;
    },
    materialConfirm(data) {
      data.forEach((item) => {
        let flag = false;
        this.listValue.forEach((element) => {
          if (element.FJNAME == item.FJNAME && element.FJURL == item.FJURL) {
            flag = true;
          }
        });
        if (!flag) {
          let listData = {
            fileName: item.FJNAME,
            fileIcon: this.getType(item.FJNAME),
            fileStatus: 1,
            fileComplete: 0,
            fileUrl: item.FJURL,
          };
          console.log(this.list, this.listValue);
          this.list.push(listData);
          this.listValue.push(item);
        }
      });
      this.$emit("input", this.listValue);
      console.log("materialConfirm", data);
    },
  },
  created() {
    //初始化
    this.listValue = clonedeep(this.value);
    this.list = clonedeep(this.value);
  },
  mounted() {},
};
</script>
<style lang="scss" scoped>
.file-upload {
  .material-selection {
    font-size: 14px;
    font-weight: 500;
    color: #1d84ff;
  }
  .file-upload-content {
    font-size: 11px;
    font-weight: 500;
    color: #999999;
    margin-bottom: 12px;
  }
  .file-upload-wrapper {
    display: flex;
    flex-wrap: wrap;
    .file-upload-preview {
      width: 55px;
      height: 55px;
      margin-right: 20px;
      position: relative;
      border: 1px solid #dddddd;
      text-align: center;
      margin-bottom: 6px;
      .delete-icon {
        position: absolute;
        top: 0;
        right: 0;
        -webkit-transform: translate(50%, -50%);
        transform: translate(50%, -50%);
        width: 14px;
        height: 14px;
      }
      .pdf-icon {
        width: 28px;
        height: 100%;
      }
    }
  }
  .upload-btn {
    width: 55px;
    height: 55px;
  }
}
</style>
